
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import BaseModal from '@/components/modals/BaseModal.vue';
import YoutubePlayer from '@/ui-components/YoutubePlayer.vue';
import { PopularTitle, Clip } from '@/interfaces/titles';
import { SnowplowTitleContext } from '@/helpers/tracking/providers/snowplow-contexts';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';

interface PlayerVars {
	autohide: number;
	autoplay: number;
	iv_load_policy: number;
	modestbranding: number;
	rel: number;
	showinfo: number;
}
@Component({
	name: 'TrailerModal',
	components: { BaseModal, YoutubePlayer },
})
export default class TrailerModal extends Vue {
	@Prop({ default: () => [] }) clip: Clip;
	@Prop() title: PopularTitle;
	@Prop({ default: null, type: Number }) seasonNumber: number;
	@Prop({ default: null, type: Number }) episodeNumber: number;
	@Prop({ default: '' }) source: string;
	@Prop({ default: false }) autoplay?: boolean;

	private isActive = false;

	trackingMap: any = {
		buffering: 'youtube_buffering',
		playing: 'youtube_playing',
		paused: 'youtube_paused',
	};
	playerVars: PlayerVars = {
		autohide: 1,
		autoplay: 1,
		iv_load_policy: 3,
		modestbranding: 1,
		rel: 0,
		showinfo: 0,
	};

	onTrack(eventName: string) {
		const category = this.trackingMap[eventName];
		const titleContext = new SnowplowTitleContext(
			this.title.id,
			this.title.object_type,
			this.seasonNumber,
			this.episodeNumber
		);
		if (category) {
			TrackingHelper.trackEvent(
				category,
				{
					action: this.title.object_type,
					label: this.source,
					nonInteraction: this.autoplay,
				},
				[titleContext]
			);
		}
	}

	private onActivate(clipId: string | null) {
		this.isActive = clipId === this.clip.external_id;
	}
}
